// 监控所有图片加载完成后显示视频mppppppppppppppp4
class ImagePreloader {
  constructor() {
    this.imageLoadHandlers = new WeakMap();
    this.loadedCount = 0;
    this.totalCount = 0;
    this.callback = null;
  }

  // 检查所有图片加载状态
  checkAllImagesLoaded(callback) {
    this.callback = callback;
    const images = document.querySelectorAll('img');
    this.totalCount = images.length;
    this.loadedCount = 0;
    console.log('进来没')
    if (this.totalCount === 0) {
      this.allImagesLoaded();
      return;
    }

    images.forEach(img => {
      if (img.complete) {
        this.handleImageLoad();
      } else {
        const loadHandler = this.handleImageLoad.bind(this);
        const errorHandler = this.handleImageLoad.bind(this); 
        img.addEventListener('load', loadHandler);
        img.addEventListener('error', errorHandler);
        
        this.imageLoadHandlers.set(img, { 
          load: loadHandler, 
          error: errorHandler 
        });
      }
    });
  }

  // 处理单张图片加载
  handleImageLoad() {
    this.loadedCount++;
    if (this.loadedCount === this.totalCount) {
      this.allImagesLoaded();
    }
  }

  // 所有图片加载完成
  allImagesLoaded() {
    if (this.callback) {
      this.callback();
    }
  }

  // 销毁方法，清理事件监听
  destroy() {
    const images = document.querySelectorAll('img');
    images.forEach(img => {
      const handlers = this.imageLoadHandlers.get(img);
      if (handlers) {
        img.removeEventListener('load', handlers.load);
        img.removeEventListener('error', handlers.error);
      }
    });
    this.imageLoadHandlers = new WeakMap();
  }
}

export default ImagePreloader;